import React, { useCallback } from 'react';
import { compose, omit } from 'ramda';
import { defaultProps, mapProps, withHandlers } from 'recompose';
import { withTranslations } from 'js/components/hocs/withTranslations';
import { Button } from 'js/components/common/Button';
import withGameLaunch from 'js/components/common/Game/withGameLaunch';
import style from './index.scss';
import classNames from '../../CasinoLeaderBoard/Details/classNames';

export const tKeyPrefix = 'playtech.mobile.system.button';

export const PlayButton = compose(
    defaultProps({
        mode: 1,
        className: '',
        tKey: `${tKeyPrefix}.realPlay`
    }),
    withTranslations,
    withGameLaunch,
    withHandlers({
        launchGame: ({ launchGame, trackChangeGameClick, gameIndexInArray, code }) => (data) => {
            if (trackChangeGameClick) {
                trackChangeGameClick(code, gameIndexInArray);
            }
            launchGame(data);
        }
    }),
    mapProps(omit(['code']))
)(({
    launchGame,
    gameLaunchType,
    name: gameName,
    mode,
    tKey,
    t,
    className = '',
    isMissions,
    isHoverBtn,
    container,
    gameFeed,
    queryString,
    onGameLaunched,
    hideButtons,
    isDesktop,
    isShowPlayButtonOnHover,
    ...others
}) => {
    const onClick = useCallback(() => {
        if (isMissions && isDesktop && hideButtons) { return; }
        launchGame({
            container,
            gameFeed,
            gameName,
            queryString,
            onGameLaunched,
            gameLaunchType,
            launchType: mode ? 'Real' : 'Demo'
        });
    }, [launchGame, container, gameFeed, gameName, queryString, onGameLaunched, gameLaunchType, mode, isMissions,
        isDesktop, hideButtons]);

    return isShowPlayButtonOnHover ? <div onClick={onClick} className={classNames(style.playImage,
        { [style.missionsImage]: isMissions })}/> :
        <Button
            onClick={onClick}
            className={`${className} ${style.button} ${isHoverBtn ? style[mode ? 'play' : 'demo'] : ''}`}
            {...others}>
            {t(tKey)}
        </Button>;
});

export const DemoButton = props =>
    <PlayButton
        mode={0}
        tKey={`${tKeyPrefix}.demoPlay`}
        view="secondary"
        color="info"
        {...props}
    />;
